import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BusCalculationComponent } from './bus-calculation.component';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChartModule } from 'primeng/chart';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';

@NgModule({
    declarations: [BusCalculationComponent],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        ChartModule,
        DropdownModule,
        ButtonModule
    ],
    exports: [
        BusCalculationComponent
    ]
})
export class BusCalculationModule { }
